// Page 404 — affichée pour toute URL inconnue.
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div data-testid="page-404" className="fenua-fade-up flex flex-col items-center justify-center text-center py-16">
      <div className="h-16 w-16 rounded-2xl bg-[#E8F4F4] flex items-center justify-center mb-6">
        <Compass className="h-8 w-8 text-[#2D5A5A]" />
      </div>
      <p className="text-5xl font-black text-[#1D3D3D] tracking-tight">404</p>
      <h1 className="mt-3 text-xl font-bold text-[#1D3D3D]">Page introuvable</h1>
      <p className="mt-2 max-w-md text-sm text-[#1D3D3D]/70">
        La page que vous cherchez n'existe pas ou a été déplacée. Vérifiez l'adresse ou revenez à votre tableau de bord.
      </p>
      <Button data-testid="bouton-retour-accueil" onClick={() => navigate("/tableau-de-bord")}
        className="mt-6 bg-[#1D3D3D] hover:bg-[#2D5A5A] text-white font-semibold">
        <ArrowLeft className="h-4 w-4 mr-1" /> Retour au tableau de bord
      </Button>
    </div>
  );
}
